import { Injectable } from '@nestjs/common';
import { EmployeeTrainingDTO } from './employee-training.dto';
import { EmployeeTrainingEntity } from '../employee-training-entity';

@Injectable()
export class EmployeeTrainingAdapter {

    public convertDtoToEntity(trainingDto: EmployeeTrainingDTO): EmployeeTrainingEntity {
        const employeetraining = new EmployeeTrainingEntity();
        console.log(trainingDto,'trainingDto++++++++++Adapter')
        employeetraining.trainingTitle = trainingDto.trainingTitle;
        employeetraining.dateOfTraining = trainingDto.dateOfTraining;
        employeetraining.dateOfTraining = trainingDto.dateOfTraining;
        employeetraining.faculty = trainingDto.faculty;
        employeetraining.duration = trainingDto.duration;
        employeetraining.topicCovered = trainingDto.topicCovered;
        employeetraining.employeeCode = trainingDto.employeeCode;
        employeetraining.employeeName = trainingDto.employeeName;
        employeetraining.plant =trainingDto.plant
        employeetraining.isActive = trainingDto.isActive == undefined ? true : trainingDto.isActive;
        if (trainingDto.trainingId) {
            employeetraining.trainingId = trainingDto.trainingId;
            employeetraining.updatedUser = trainingDto.createdUser;
        } else {
            employeetraining.isActive = true;
            employeetraining.createdUser = trainingDto.createdUser;
        }
        return employeetraining;
    }

}